import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"height":"80vh"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DocumentsTable = _resolveComponent("DocumentsTable")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_Document = _resolveComponent("Document")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.addDocumentDialog)
    ? (_openBlock(), _createBlock(_component_oss_dialog, {
        key: 0,
        modelValue: _ctx.addDocumentDialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addDocumentDialog) = $event)),
        title: _ctx.alreadyLinkedDoc ? 'Document lié' : 'Lier un ou plusieurs document(s)',
        actions: _ctx.actions,
        "previous-display": _ctx.dialogStep === 'displayDocument' && !_ctx.alreadyLinkedDoc,
        onPrevious: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogPreviousAction())),
        onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeDialog())),
        "min-width": "1500px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.dialogStep,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogStep) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "addDocument" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                    style: {"background-color":"transparent !important","border-radius":"16px","overflow":"hidden"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, {
                        value: "ExistingDocuments",
                        href: "#ExistingDocuments"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode(" Documents existants ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        value: "UploadDocument",
                        href: "#UploadDocument"
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" Ajouter un document ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_v_tabs_window, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTab) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: "ExistingDocuments" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  (_ctx.addDocumentDialog)
                                    ? (_openBlock(), _createBlock(_component_DocumentsTable, {
                                        key: 0,
                                        selectMode: true,
                                        actions: _ctx.selectActions,
                                        preSelectedAuditCheckDocuments: _ctx.localConnectedDocuments || [],
                                        height: "70vh",
                                        onDocumentIdToDisplay: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayDocument($event))),
                                        onAddDocumentInList: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNewDocument($event))),
                                        onSelectedDocuments: _cache[3] || (_cache[3] = ($event: any) => (_ctx.replaceList($event))),
                                        onValidSelection: _ctx.validDocumentsSelection
                                      }, null, 8, ["actions", "preSelectedAuditCheckDocuments", "onValidSelection"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "UploadDocument" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex justify-center"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.addDocumentDialog && _ctx.activeTab === 'UploadDocument')
                                    ? (_openBlock(), _createBlock(_component_UploadDocuments, {
                                        key: 0,
                                        documentType: 'MISCELLANEOUS',
                                        ref: "uploadDocuments",
                                        showFirstPrevious: true,
                                        companyId: _ctx.companyId,
                                        freeTag: false,
                                        actions: _ctx.uploadActions,
                                        auditCheckMode: true,
                                        inExtensions: [
                                        'jpeg',
                                        'jpg',
                                        'png',
                                        'tiff',
                                        'tif',
                                        'pdf',
                                        'docx',
                                        'xlsx',
                                        'csv',
                                    ],
                                        onFilesUploaded: _ctx.onFilesUploaded,
                                        onNewDocument: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewDocument($event)))
                                      }, null, 8, ["companyId", "actions", "onFilesUploaded"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "displayDocument" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.documentToShow)
                      ? (_openBlock(), _createBlock(_component_Document, {
                          key: 0,
                          mode: 'GeneralLedger',
                          companyId: _ctx.companyId,
                          id: _ctx.documentToShow.id,
                          "dark-mode": true
                        }, null, 8, ["companyId", "id"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "actions", "previous-display"]))
    : _createCommentVNode("", true)
}